import axios from "axios";
import { getToken, checkTokenError } from "./shared/utility";

const UNAUTHORIZED = 401;

const graphQLClientInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL!,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  }
});

graphQLClientInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token && !checkTokenError(token)) {
      config.headers["x-auth"] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

graphQLClientInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const {status} = error.response;
      if (status === UNAUTHORIZED) {
        window.location.replace(process.env.REACT_APP_LOGIN_URL!);
      }
    }
    return Promise.reject(error);
 }
);

export default graphQLClientInstance;
